import { ReactNode } from "react"
import { AvtarIcon, HeartIconDark, HelpIcon, HistoryIcon, MapIcon, MedicineIcon, PrescriptionIcon } from "./Icons"

interface myAccountListsTypes {
    icon: ReactNode,
    title: string,
    link: string,
    tab?: number
}
export const myAccountLists: myAccountListsTypes[] = [
    {
        icon: <AvtarIcon color="#242424" />,
        title: 'Manage Profile',
        link: '/myaccount/profile',
        tab: 0,
    },
    {
        icon: <MapIcon color="#242424" />,
        title: 'Address Book',
        link: '/myaccount/address',
        tab: 1,
    },
    {
        icon: <HeartIconDark color="#242424" />,
        title: 'Favorites',
        link: '/myaccount/favorites',
        tab: 2,
    },
    {
        icon: <MedicineIcon color="#242424" />,
        title: 'My Medicine',
        link: '/myaccount/mymedicine',
        tab: 3,
    },
    {
        icon: <HistoryIcon color="#242424" />,
        title: 'Order History',
        link: '/myaccount/order-history',
        tab: 4,
    },
    {
        icon: <PrescriptionIcon color="#242424" />,
        title: 'My prescription',
        link: '/myaccount/my-prescription',
        tab: 5,
    },
    {
        icon: <HelpIcon color="#242424" />,
        title: 'Need Help?',
        link: '/myaccount/help',
        tab: 6,
    },

]